// src/admin/manage-users/AddUserPage.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getFunctions, httpsCallable } from 'firebase/functions';

const ROLES = ['normalUser', 'subscribedUser', 'editor', 'marketing', 'order', 'admin'];

const AddUserPage = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        displayName: '',
        role: 'normalUser',
        profession: '',
        phone: '',
        address: '',
        twitter: '',
        linkedin: '',
        website: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.email || !formData.password) {
            setError("Email and Password are required.");
            return;
        }
        setLoading(true);
        setError('');
        try {
            const functions = getFunctions();
            const createUserByAdmin = httpsCallable(functions, 'createUserByAdmin');
            await createUserByAdmin(formData);
            alert('User created successfully!');
            navigate('/admin/manage-users');
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h2 className="mb-4">Add New User</h2>
            {error && <div className="alert alert-danger">{error}</div>}
            <div className="card">
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        {/* Form fields */}
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label htmlFor="email" className="form-label">Email Address*</label>
                                <input type="email" id="email" name="email" className="form-control" value={formData.email} onChange={handleChange} required />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label htmlFor="password" className="form-label">Password*</label>
                                <input type="password" id="password" name="password" className="form-control" value={formData.password} onChange={handleChange} required />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label htmlFor="displayName" className="form-label">Full Name</label>
                                <input type="text" id="displayName" name="displayName" className="form-control" value={formData.displayName} onChange={handleChange} />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label htmlFor="role" className="form-label">User Role</label>
                                <select id="role" name="role" className="form-select" value={formData.role} onChange={handleChange}>
                                    {ROLES.map(role => <option key={role} value={role}>{role}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label htmlFor="profession" className="form-label">Profession</label>
                                <input type="text" id="profession" name="profession" className="form-control" value={formData.profession} onChange={handleChange} />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label htmlFor="phone" className="form-label">Phone</label>
                                <input type="tel" id="phone" name="phone" className="form-control" value={formData.phone} onChange={handleChange} />
                            </div>
                        </div>
                         <div className="mb-3">
                            <label htmlFor="address" className="form-label">Address</label>
                            <input type="text" id="address" name="address" className="form-control" value={formData.address} onChange={handleChange} />
                        </div>
                        <hr />
                        <h5 className="my-3">Social & Website Links</h5>
                         <div className="row">
                            <div className="col-md-4 mb-3">
                                <label htmlFor="website" className="form-label">Website</label>
                                <input type="url" id="website" name="website" className="form-control" value={formData.website} onChange={handleChange} />
                            </div>
                            <div className="col-md-4 mb-3">
                                <label htmlFor="twitter" className="form-label">Twitter URL</label>
                                <input type="url" id="twitter" name="twitter" className="form-control" value={formData.twitter} onChange={handleChange} />
                            </div>
                            <div className="col-md-4 mb-3">
                                <label htmlFor="linkedin" className="form-label">LinkedIn URL</label>
                                <input type="url" id="linkedin" name="linkedin" className="form-control" value={formData.linkedin} onChange={handleChange} />
                            </div>
                        </div>
                        
                        {/* Action Buttons */}
                        <div className="mt-3">
                            <button type="submit" className="btn btn-primary me-2" disabled={loading}>
                                {loading ? 'Creating User...' : 'Create User'}
                            </button>
                            <button type="button" onClick={() => navigate('/admin/manage-users')} className="btn btn-secondary">
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddUserPage;